import * as React from 'react';

import { cn } from '@rematter/ui-web';

type StatusVariant = 'success' | 'failure' | 'warning' | 'info';

export interface StatusIndicatorProps {
  variant: StatusVariant;
  icon: React.ReactNode;
}

const variantStyles: Record<StatusVariant, string> = {
  success: 'bg-success/10 text-success',
  failure: 'bg-failure/10 text-failure',
  warning: 'bg-warning/10 text-warning',
  info: 'bg-info/10 text-info',
};

export const StatusIndicator = ({ variant, icon }: StatusIndicatorProps) => (
  <div
    className={cn(
      '@StatusIndicator',
      'h-10 flex-col content-center rounded-md px-3',
      variantStyles[variant],
    )}
  >
    {icon}
  </div>
);
